import React, { useEffect, useState } from 'react';
import './VideoBackground.css'; // Подключаем стили
import './animatedWishlist.css';
import './VideoBackgroundMobile.css';


import videoFile from '../../media/background_view_ver1.mp4';
import logo from '../../media/logo.png'; // Путь к логотипу
import { useLanguage } from '../switchLang/useLang';
import SubscribeWidget from '../newsletterSub/SubscribeWidget';
import { KickstarterWidget } from '../KikStart/KickstarterWidget';
import KikSvgImageMini from '../KikStart/KikSvgMini';

import KickstarterStatusBadge from '../KikStart/KickstarterStatusBadge';

const VideoBackgroundComponent = () => {
    const { t, lang } = useLanguage(); // Получаем функцию переключения и текущий язык
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        // Таймер для запуска анимации через секунду после открытия
        const timer = setTimeout(() => {
            setIsActive(true);
        }, 500); // Задержка перед запуском
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="video-background">
            {/* Видео на фоне */}
            <video className="video-bg" autoPlay muted loop playsInline>
                <source src={videoFile} type="video/mp4" />
                Ваш браузер не поддерживает видео.
            </video>

            {/* Контент поверх видео */}
            <div className={`content ${isActive ? 'active' : ''}`}>
                <img src={logo} alt="Silicone Heart Logo" className="logo" />
                {/* <p><b>{t("description")}</b></p> */}
                <p>{t("descriptionMore")}</p>
                <KickstarterStatusBadge />
                {/* <a href="https://store.steampowered.com/app/3340880/Silicone_Heart" target="_blank" rel="noopener noreferrer">
                    <button className="wishlist-button">
                        {t('wishlist')}
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </a> */}
                {/* <a href={lang === 'en' ? "https://drive.google.com/drive/u/0/folders/176Xhuxww1j1vHMBoIyaDgkY_T9QSBdiY" : "https://drive.google.com/drive/folders/1f8NXooVk-Add8Ne_Eiu690ErITjhkeqT"} target="_blank" rel="noopener noreferrer">
                    <button>{t('presskit')}</button>
                </a> */}
                <a>
                    <SubscribeWidget />
                </a>
                <a href="https://www.kickstarter.com/projects/gardenofdreamsgames/silicone-heart">
                    <div className="kickMobile">
                        <KikSvgImageMini className="kikSvgMini" />
                    </div>
                </a>
            </div>
            <KickstarterWidget />
        </div >
    );
};

export default VideoBackgroundComponent;
